import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordVisibilityField = ({ testId, ...props }) => {
  const [visible, setVisible] = useState(false);
  return <div className="relative min-w-0">
    <Input {...props} type={visible ? "text" : "password"} className="pr-11" data-testid={testId} />
    <button type="button" onClick={() => setVisible((value) => !value)}
      aria-label={visible ? "Nascondi password" : "Mostra password"}
      title={visible ? "Nascondi password" : "Mostra password"}
      className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-[#707070] hover:text-[#1A1A1A] transition-colors"
      data-testid={`${testId}-visibility-toggle`}>
      {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
    </button>
  </div>;
};